const locales = ["en", "es", "fr", "it", "de"];
const localeMap = {  
  en: "en",
  es: "es",
  fr: "fr",
  it: "it",
  de: "de",
};

const languageMap = {  
  en: "English",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  de: "Deutsch",
};

export { locales, localeMap, languageMap };
